import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc
} from "firebase/firestore";
import { db, isFirebaseConfigured } from "./firebase";
import type { Reservation, ReservationRequest, ReservationStatus } from "../types";

export async function createReservation(request: ReservationRequest): Promise<string> {
  if (!request.privacyAccepted) {
    throw new Error("Datenschutz muss akzeptiert werden.");
  }

  if (!isFirebaseConfigured || !db) {
    throw new Error("Der Reservierungsdienst ist derzeit nicht verfügbar.");
  }

  const result = await addDoc(collection(db, "reservations"), {
    ...request,
    status: "neu",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    source: "website"
  });

  return result.id;
}

export async function loadReservations(): Promise<Reservation[]> {
  if (!isFirebaseConfigured || !db) {
    throw new Error("Firebase ist nicht konfiguriert.");
  }

  const snapshot = await getDocs(query(collection(db, "reservations"), orderBy("createdAt", "desc")));
  return snapshot.docs.map((item) => {
    const data = item.data();
    return {
      id: item.id,
      name: String(data.name ?? ""),
      persons: Number(data.persons ?? 0),
      date: String(data.date ?? ""),
      time: String(data.time ?? ""),
      email: String(data.email ?? ""),
      phone: String(data.phone ?? ""),
      note: String(data.note ?? ""),
      privacyAccepted: Boolean(data.privacyAccepted),
      status: (data.status ?? "neu") as ReservationStatus,
      createdAt: data.createdAt?.toDate?.().toISOString?.() ?? "",
      updatedAt: data.updatedAt?.toDate?.().toISOString?.() ?? ""
    };
  });
}

export async function updateReservationStatus(id: string, status: ReservationStatus): Promise<void> {
  if (!isFirebaseConfigured || !db) {
    throw new Error("Firebase ist nicht konfiguriert.");
  }

  await updateDoc(doc(db, "reservations", id), {
    status,
    updatedAt: serverTimestamp()
  });
}
